import React from "react";
import { useEffect, useState } from "react";
import { EmployeeRecordsVM } from "../../Models/ViewModels";
import * as Employee from "../../Services/EmployeeDB";
import { ToastContainer, toast } from 'react-toastify';
import { AnyPtrRecord } from "dns";
import * as userManager from '../../Services/UserSessionManager';
import { GetUserLoginID } from "../../Services/UserSessionManager";

export const EditInfo = (props: any) => {
  const [checkRole,setCheckRole]=useState(userManager.GetUserRole());
  const [cachedEmployeesList, setCachedEmployeesList] = useState(new Array<EmployeeRecordsVM>())
  const [loginid, setLoginid] = useState(GetUserLoginID())
  const handleChange = (event: any) => {

    let name = event.target.name;
    let value = event.target.value;


    let empList: any = [...cachedEmployeesList];
    empList[0][name] = value;

    setCachedEmployeesList(empList);
  }

  const handleUpdate = () => {
    Employee.EditEmployeeDetails(cachedEmployeesList[0]).then((result) => {
   //getEmployeeRecords(props.id)
   
      toast.info("Updated successfully");
    })
  }


  const getEmployeeRecords = (id: any) => {

    Employee.GetEmployeeRecords(id).then(res => {
      if (res.data) {
        setCachedEmployeesList(res.data);
      }

    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    getEmployeeRecords(props.id);
  }, [])

  return <>
    {
      cachedEmployeesList && cachedEmployeesList.length > 0 &&

      <div className="d-flex flex-column gap-2">
        <div><b>Edit Details</b></div>

        <div>
          Xlite Extension Number
          <input type="text" className="form-control" name="XliteExtensionNumber" aria-label="Sizing example input" defaultValue={cachedEmployeesList[0].XliteExtensionNumber} onChange={handleChange} aria-describedby="inputGroup-sizing-sm" /> </div>
          <div>
          Prev. Relevant Exp(months)
          <input type="number" className="form-control" name="RCMTenurity" aria-label="Sizing example input" defaultValue={cachedEmployeesList[0].RCMTenurity} onChange={handleChange} aria-describedby="inputGroup-sizing-sm" />
         </div>
        <div>
           Workstation
          <input type="text" className="form-control" name="WorkStationNumber" defaultValue={cachedEmployeesList[0].WorkStationNumber} onChange={handleChange} aria-describedby="inputGroup-sizing-sm" />
        </div>

        {checkRole=='M'||checkRole=='A'? 
        <div>
                    <div>
                    Ramp Up Field
                    <select className="form-tree" name="Ramp_up_state" value={cachedEmployeesList[0].Ramp_up_state||''} onChange={handleChange}>
                   <option value='null'>--Select--</option>
                   <option >Trainee</option>
                   <option >Ramp-up</option>
                   <option >Steady state</option>
                 </select>
                  </div>  
               
               

         
  
        <div>
        Role 
        <div>
        <select className="form-tree"  defaultValue={cachedEmployeesList[0].ProductionRole} name="ProductionRole"  onChange={handleChange}>
        <option>--Select--</option>
       <option >Production (Agent)</option>
       <option >Non-Production (Manager)</option>
       <option>Non-Production (Lead)</option>
       <option>Non-production (Other)</option>
     </select>
      </div></div>
      </div>
               
               :<></>}
        <div>
          <button type="button" className="btn btn-primary mt-2" onClick={handleUpdate} >Submit</button>
        </div>
      </div>
    }
  </>
}